import React, { useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

import {
  FreeBetsWrapper,
  isMobile,
  loadingStore,
  LocalStorageWrapper,
  platformMessageStore,
  SlowConnectionWr,
  UnderMaintenanceWr,
  useTranslation,
  applicationStore,
  freeBetStore,
  roundInfoStore,
} from '@pascal/pascal-core';

import { gameDrawer } from '../drawers';
import { NumPad } from '../../components/numPad';
import { gameStore } from '../../store/gameStore';
import TurboModePopUp from '../../components/turboModePopUp';
import GameCenterSide from '../../containers/gameCenterSide';
import { TranslationKeys } from '../../enums/translationKeys';
import RoundResultPart from '../../components/roundResultPart';
import { specificLocalStorageKeys } from '../../enums/constants';

export const MobileGameMain = observer(() => {
  const [currentRoundId, setCurrentRoundId] = useState(null);
  const { resetGameState, isTurboModeExist } = gameStore;
  const { endedFreeBets } = freeBetStore;
  const t = useTranslation();
  const { roundId } = roundInfoStore;
  const { isDemo } = applicationStore;
  const { isRepliedGame } = platformMessageStore;
  const ref = useRef();

  useEffect(() => {
    if (roundId && !isDemo) {
      setCurrentRoundId(roundId);
    }
  }, [roundId, isDemo]);

  useEffect(() => {
    if (!ref.current) return;
    gameDrawer.setupRoot(ref.current);
  }, [ref.current]);

  const handleDemoSwitcher = useCallback(() => {
    applicationStore.demoSwitcher(resetGameState);
  }, [resetGameState]);

  useEffect(() => {
    if (endedFreeBets.length) {
      freeBetStore.handleFreeBetEndedData();
    }
  }, [endedFreeBets.length]);

  useEffect(() => {
    gameDrawer
      .execute({
        mode: isMobile() ? 'mobile' : 'web',
        scene: 'Main',
        prevScene: null,
      })
      .then(() => {
        loadingStore.updateLoading({ isPixiLoaded: true });
      });
  }, []);

  return (
    <>
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <div className='crazy-worm-wrapper'>
        <div ref={ref} />
        {/*<div className='crazy-mob-header'>*/}
        {/*  <p className='round-id'>*/}
        {/*    {!isDemo ? t(TranslationKeys.RoundId) : ''}*/}
        {/*    <span>{currentRoundId}</span>*/}
        {/*  </p>*/}
        {/*  <img src={logo} alt='' className='mob-logo' />*/}
        {/*  {isDemo ? (*/}
        {/*    <button className='crazy-mob-play' type='button' onClick={handleDemoSwitcher}>*/}
        {/*      {t(TranslationKeys.PlayForReal)}*/}
        {/*    </button>*/}
        {/*  ) : (*/}
        {/*    <FreeBetsWrapper />*/}
        {/*  )}*/}
        {/*</div>*/}
        {/*<img src={logo} className='crazy-worm-logo' alt='#' />*/}
        <FreeBetsWrapper />
        {!isRepliedGame && isTurboModeExist && (
          <LocalStorageWrapper localStorageKey={specificLocalStorageKeys.isTurboModePopUp}>
            <TurboModePopUp t={t} />
          </LocalStorageWrapper>
        )}
        <GameCenterSide />
        <RoundResultPart />
        <NumPad />
      </div>
    </>
  );
});
